/* eslint-disable max-len */
import React from 'react';
type Props = { color: string };
/**
 * @param color - color of the circle containing a white cross
 */
export function CrossColorable(props: Props): JSX.Element {
  const { color } = props;
  return (
    <svg
      data-test-id="cross-icon"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11" cy="11" r="11" fill={color} />
      <path
        d="M13.8359 13.095C14.0328 13.3131 14.0328 13.6402 13.8359 13.8364C13.6172 14.0545 13.2891 14.0545 13.0922 13.8364L10.5109 11.2414L7.90781 13.8364C7.68906 14.0545 7.36094 14.0545 7.16406 13.8364C6.94531 13.6402 6.94531 13.3131 7.16406 13.095L9.76719 10.5L7.16406 7.90498C6.94531 7.68692 6.94531 7.35981 7.16406 7.16355C7.36094 6.94548 7.68906 6.94548 7.88594 7.16355L10.5109 9.78037L13.1141 7.18536C13.3109 6.96729 13.6391 6.96729 13.8359 7.18536C14.0547 7.38162 14.0547 7.70872 13.8359 7.92679L11.2328 10.5L13.8359 13.095Z"
        fill="white"
        transform="translate(0.5 0.5)"
      />
    </svg>
  );
}
